import { createAction } from 'services/actionConfigs';
import { createAsyncAction } from 'store/actionConfigs';

const PREFIX_ACTIONS = 'shop_feature_';

const shopActions = {
  shopInfo: createAsyncAction(PREFIX_ACTIONS + 'getShopInfo'),
  staff: createAsyncAction(PREFIX_ACTIONS + 'getStaffs'),
  category: createAsyncAction(PREFIX_ACTIONS + 'category'),
  coupons: createAsyncAction(PREFIX_ACTIONS + 'coupons'),
  depositSetting: createAsyncAction(PREFIX_ACTIONS + 'depositSetting'),
  salonScheduler: createAsyncAction(PREFIX_ACTIONS + 'salonScheduler'),
  availableStaffByTimeSlot: createAsyncAction<{ startTime: string, endTime: string }, { id: string }[]>(PREFIX_ACTIONS + 'availableStaffByTimeSlot'),
  promotion: createAsyncAction(PREFIX_ACTIONS + 'promotion'),
  doInit: createAction<string>(PREFIX_ACTIONS + 'doInitShopData'),
  galleries: createAsyncAction(PREFIX_ACTIONS + 'getSalonGallery'),
};

export default shopActions;

